export const TEXT_FROM_911 = 'textFrom911';
export const CALL_TYPES_WHITELIST = [TEXT_FROM_911];
